<template>
  <div id="users_detail">
    <Navbar
      current="Detalhes do paciente"
      :link="$paths.users.list"
      :linkName="'Pacientes'"
    />
    <Sidebar />
    <Container>
      <Header title="Detalhes do Paciente">
        <template v-slot:button>
          <button
            v-if="!loading && !item.deleted_at"
            @click="showResetPasswordModal = true"
            class="btn btn-outline-secondary"
          >
            <i class="fa-solid fa-key"></i> Gerar link de senha
          </button>
          <button
            v-if="!loading && item.deleted_at"
            @click="showReactivateModal = true"
            class="btn btn-success ms-3"
          >
            <i class="fa-solid fa-rotate-left"></i> Reativar conta
          </button>
          <template v-if="!loading && !item.deleted_at">
            <a
              :href="
                'https://api.whatsapp.com/send?phone=55' +
                $helper.cleanValue(item.phone) +
                '&text&type=phone_number&app_absent=0'
              "
              target="_blank"
              type="button"
              class="btn btn-success ms-3"
            >
              <i class="fa-brands fa-whatsapp"></i>
              Enviar mensagem
            </a>

            <button
              @click="freeAppointment()"
              class="btn btn-outline-secondary ms-3"
            >
              Sessão Gratuita
            </button>

            <button
              v-if="item.active"
              @click="changeActive()"
              class="btn btn-outline-secondary ms-3"
            >
              <i class="fa-solid fa-lock"></i>
              Inativar
            </button>
            <button v-else @click="changeActive()" class="btn btn-light ms-3">
              <i class="fa-solid fa-lock-open"></i>
              Ativar
            </button>

            <a
              class="btn btn-primary lift ms-3"
              :href="`${$paths.users.edit}/${id}`"
            >
              Editar
              <i class="fa-solid fa-pen me-1"></i>
            </a>
          </template>
        </template>
      </Header>
      <LoadingContainer v-if="loading" />
      <div v-else>
        <div class="row my-4" v-if="item.deleted_at">
          <div class="col-12">
            <span class="alert alert-danger d-flex justify-content-center mb-0"
              >Conta excluída</span
            >
          </div>
        </div>
        <div class="card">
          <ul class="nav nav-tabs ps-4 pt-3" id="userTab" role="tablist">
            <li class="nav-item active" role="presentation">
              <button
                class="nav-link active"
                id="info-tab"
                data-bs-toggle="tab"
                data-bs-target="#info"
                type="button"
                role="tab"
                aria-controls="info"
                aria-selected="true"
              >
                Informações
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="journey-tab"
                data-bs-toggle="tab"
                data-bs-target="#journey"
                type="button"
                role="tab"
                aria-controls="journey"
                aria-selected="false"
              >
                Jornada
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="recurrencies-tab"
                data-bs-toggle="tab"
                data-bs-target="#recurrencies"
                type="button"
                role="tab"
                aria-controls="recurrencies"
                aria-selected="false"
              >
                Recorrências
                <span class="badge bg-primary-soft" style="font-size: 0.8rem">{{
                  item.recurrencies?.length || 0
                }}</span>
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="appointments-tab"
                data-bs-toggle="tab"
                data-bs-target="#appointments"
                type="button"
                role="tab"
                aria-controls="appointments"
                aria-selected="false"
                @click="loadAppointmentsTab"
              >
                Sessões
                <span
                  class="badge bg-primary-soft"
                  style="font-size: 0.8rem"
                  >{{ item.appointments_count }}</span
                >
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="partnership-tab"
                data-bs-toggle="tab"
                data-bs-target="#partnership"
                type="button"
                role="tab"
                aria-controls="partnership"
                aria-selected="false"
              >
                Parceria com empresa
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="change-logs-tab"
                data-bs-toggle="tab"
                data-bs-target="#change-logs"
                type="button"
                role="tab"
                aria-controls="change-logs"
                aria-selected="false"
                @click="loadChangeLogsTab"
              >
                Histórico de Alterações
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="notifications-tab"
                data-bs-toggle="tab"
                data-bs-target="#notifications"
                type="button"
                role="tab"
                aria-controls="notifications"
                aria-selected="false"
                @click="loadNotificationsTab"
              >
                Notificações
              </button>
            </li>
          </ul>
          <div class="tab-content" id="userTabContent">
            <!-- Info Tab -->
            <div
              class="tab-pane card-body fade show active"
              id="info"
              role="tabpanel"
              aria-labelledby="info-tab"
            >
              <div class="row">
                <h3>Informações do paciente</h3>
                <div class="col-12 col-xl-12 mb-2">
                  <img
                    src="@/assets/img/avatar.png"
                    alt="..."
                    class="avatar-img avatar-lg rounded-circle avatar-sm"
                  />
                  <span class="text-muted ps-3"
                    >{{ item.name }}
                    <a
                      :href="item.stripe_link"
                      target="_blank"
                      v-if="item.stripe_link"
                    >
                      <i
                        class="fa-brands fa-cc-stripe fa-xl text-dark"
                        style="margin-left: 5px"
                      ></i>
                    </a>
                  </span>
                </div>
                <div class="col-12 col-xl-4">
                  <TextInput
                    :readOnly="true"
                    label="Apelido"
                    :value="item.nickname"
                  />
                </div>
                <div class="col-12 col-xl-5">
                  <TextInput
                    :readOnly="true"
                    label="Email"
                    :value="item.email"
                  />
                </div>
                <div class="col-12 col-xl-3">
                  <TextInput
                    :readOnly="true"
                    label="CPF"
                    :mask="'###.###.###-##'"
                    :value="item.document_number"
                  />
                </div>

                <div class="col-12 col-xl-6">
                  <div class="form-group">
                    <label class="form-label">Telefone</label>
                    <div class="input-group">
                      <span class="input-group-text" v-if="item.country_code">
                        {{ getCountryFlag(item.country_code) }}
                        {{ item.country_code }}
                      </span>
                      <input
                        type="text"
                        class="form-control"
                        :value="item.phone"
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <TextInput
                    :readOnly="true"
                    label="Data de criação"
                    :value="item.formatted_created_at"
                  />
                </div>
                <div class="col-12 col-xl-6">
                  <TextInput
                    :readOnly="true"
                    label="Celular"
                    :value="`${item.device_details?.os} - ${item.device_details?.model} ${item.device_details?.osVersion}`"
                  />
                </div>
                <div class="col-12 col-xl-6">
                  <TextInput
                    :readOnly="true"
                    label="Versao do psiapp"
                    :value="`${item.device_details?.appVersion}`"
                  />
                </div>
              </div>
            </div>

            <!-- Journey Tab -->
            <div
              class="tab-pane card-body fade"
              id="journey"
              role="tabpanel"
              aria-labelledby="journey-tab"
            >
              <h3>Jornada do paciente</h3>

              <div class="row">
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="card">
                    <div class="card-body text-center small">
                      <i
                        class="mb-3 fa-solid fa-circle-check text-success me-2"
                        v-if="item.milestones?.viewed_home"
                      ></i>
                      <i class="mb-3 fa-solid fa-clock text-muted" v-else></i
                      ><br />
                      Viu a home
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="card">
                    <div class="card-body text-center small">
                      <i
                        class="mb-3 fa-solid fa-circle-check text-success me-2"
                        v-if="item.milestones?.searched_psys"
                      ></i>
                      <i class="mb-3 fa-solid fa-clock text-muted" v-else></i
                      ><br />
                      Buscou psis
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="card">
                    <div class="card-body text-center small">
                      <i
                        class="mb-3 fa-solid fa-circle-check text-success me-2"
                        v-if="item.milestones?.viewed_psy"
                      ></i>
                      <i class="mb-3 fa-solid fa-clock text-muted" v-else></i
                      ><br />
                      Visualizou um psi
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="card">
                    <div class="card-body text-center small">
                      <i
                        class="mb-3 fa-solid fa-circle-check text-success me-2"
                        v-if="item.milestones?.viewed_calendar"
                      ></i>
                      <i class="mb-3 fa-solid fa-clock text-muted" v-else></i
                      ><br />
                      Viu calendário
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="card">
                    <div class="card-body text-center small">
                      <i
                        class="mb-3 fa-solid fa-circle-check text-success me-2"
                        v-if="item.milestones?.viewed_times"
                      ></i>
                      <i class="mb-3 fa-solid fa-clock text-muted" v-else></i
                      ><br />
                      Viu horários
                    </div>
                  </div>
                </div>
                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="card">
                    <div class="card-body text-center small">
                      <i
                        class="mb-3 fa-solid fa-circle-check text-success me-2"
                        v-if="item.milestones?.credit_card_registered"
                      ></i>
                      <i class="mb-3 fa-solid fa-clock text-muted" v-else></i
                      ><br />
                      Cadastrou cartão
                    </div>
                  </div>
                </div>

                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="card">
                    <div class="card-body text-center small">
                      <i
                        class="mb-3 fa-solid fa-circle-check text-success me-2"
                        v-if="item.milestones?.checked_coupon"
                      ></i>
                      <i class="mb-3 fa-solid fa-clock text-muted" v-else></i
                      ><br />
                      Aplicou cupom
                    </div>
                  </div>
                </div>

                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="card">
                    <div class="card-body text-center small">
                      <i
                        class="mb-3 fa-solid fa-circle-check text-success me-2"
                        v-if="item.milestones?.created_appointment"
                      ></i>
                      <i class="mb-3 fa-solid fa-clock text-muted" v-else></i
                      ><br />
                      Tentou sessão
                    </div>
                  </div>
                </div>

                <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div class="card">
                    <div class="card-body text-center small">
                      <i
                        class="mb-3 fa-solid fa-circle-check text-success me-2"
                        v-if="item.milestones?.concluded_appointment"
                      ></i>
                      <i class="mb-3 fa-solid fa-clock text-muted" v-else></i
                      ><br />
                      Concluiu sessão
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Recurrencies Tab -->
            <div
              class="tab-pane card-body fade"
              id="recurrencies"
              role="tabpanel"
              aria-labelledby="recurrencies-tab"
            >
              <h3>Recorrências</h3>
              <div class="row">
                <template v-if="item.recurrencies?.length">
                  <div
                    v-for="(recurrency, index) in item.recurrencies"
                    :key="index"
                    class="col-12 col-md-6 col-xl-4"
                  >
                    <div class="recurrency-card">
                      <div class="recurrency-header">
                        <router-link
                          v-if="recurrency.psychologist?.id"
                          :to="`${$paths.psychologists.detail}/${recurrency.psychologist.id}`"
                          class="recurrency-avatar-link"
                          :title="`Ver ${recurrency.psychologist.name}`"
                        >
                          <img
                            v-if="recurrency.psychologist.profile_image"
                            class="recurrency-avatar"
                            :src="`${$baseImageUrl}${recurrency.psychologist.profile_image}`"
                            alt=""
                          />
                          <div
                            v-else
                            class="recurrency-avatar recurrency-avatar-placeholder"
                          >
                            <i class="fa-solid fa-user"></i>
                          </div>
                        </router-link>
                        <div class="recurrency-header-info">
                          <router-link
                            v-if="recurrency.psychologist?.id"
                            :to="`${$paths.psychologists.detail}/${recurrency.psychologist.id}`"
                            class="recurrency-name text-truncate recurrency-name-link"
                          >
                            {{ recurrency.psychologist.name }}
                          </router-link>
                          <div v-else class="recurrency-name text-truncate">
                            {{ recurrency.psychologist?.name }}
                          </div>
                          <div class="recurrency-price">
                            R$ {{ recurrency.value }}
                          </div>
                        </div>
                        <span
                          class="recurrency-status-badge"
                          :class="{
                            'status-pending': recurrency.status === 'pending',
                            'status-active': recurrency.status === 'active',
                            'status-cancelled': !['pending', 'active'].includes(recurrency.status),
                          }"
                        >
                          <i
                            class="fa-solid me-1"
                            :class="{
                              'fa-circle-exclamation': recurrency.status === 'pending',
                              'fa-circle-check': recurrency.status === 'active',
                              'fa-circle-xmark': !['pending', 'active'].includes(recurrency.status),
                            }"
                          ></i>
                          <span v-if="recurrency.status === 'pending'">Pendente</span>
                          <span v-else-if="recurrency.status === 'active'">Ativa</span>
                          <span v-else>Cancelada</span>
                        </span>
                      </div>

                      <div class="recurrency-body">
                        <div class="recurrency-info-line">
                          <i class="fa-solid fa-calendar-days me-2 text-muted"></i>
                          <span>
                            <strong>{{ recurrencyFrequencyLabel(recurrency) }}</strong>
                            <span
                              v-if="recurrencyDayLabel(recurrency)"
                              class="text-muted"
                            >
                              · {{ recurrencyDayLabel(recurrency) }}
                            </span>
                          </span>
                        </div>
                        <div
                          v-if="hasPendingValueChange(recurrency)"
                          class="recurrency-value-change"
                        >
                          <i class="fa-solid fa-arrow-trend-up me-2"></i>
                          <span>
                            Mudança de valor agendada para
                            <strong>
                              {{ $moment(recurrency.value_change_effective_at).format("DD/MM/YYYY") }}
                            </strong>
                          </span>
                        </div>
                        <div
                          v-if="recurrency.created_at"
                          class="recurrency-info-line text-muted"
                        >
                          <i class="fa-solid fa-clock me-2"></i>
                          <small>
                            Recorrência criada em
                            {{ $moment(recurrency.created_at).format("DD/MM/YYYY") }}
                          </small>
                        </div>
                      </div>

                      <div class="recurrency-footer">
                        <router-link
                          :to="{
                            path: $paths.appointments.list,
                            query: { recurrency_id: recurrency.id },
                          }"
                          class="btn btn-outline-secondary btn-sm flex-fill"
                        >
                          <i class="fa-solid fa-calendar me-1"></i>
                          Ver sessões
                        </router-link>
                        <template v-if="recurrency.status === 'active'">
                          <button
                            class="btn btn-outline-primary btn-sm flex-fill"
                            @click="editingRecurrency = recurrency"
                          >
                            <i class="fa-solid fa-pen me-1"></i>
                            Editar
                          </button>
                          <button
                            class="btn btn-outline-danger btn-sm flex-fill"
                            :disabled="cancelingRecurrency === recurrency.id"
                            @click="handleCancelRecurrency(recurrency)"
                          >
                            <span v-if="cancelingRecurrency === recurrency.id">
                              <i class="fa-solid fa-spinner fa-spin me-1"></i>
                              Cancelando...
                            </span>
                            <span v-else>
                              <i class="fa-solid fa-ban me-1"></i>
                              Cancelar
                            </span>
                          </button>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="col-12" v-else>
                  <p class="mb-3">Nenhuma recorrência</p>
                  <hr />
                </div>
              </div>
            </div>

            <!-- Appointments Tab -->
            <div
              class="tab-pane fade"
              id="appointments"
              role="tabpanel"
              aria-labelledby="appointments-tab"
            >
              <UserDetailAppointments
                v-if="appointmentsLoaded"
                :userId="id"
                ref="appointmentsComponent"
              />
            </div>

            <!-- Partnership Tab -->
            <div
              class="tab-pane card-body fade"
              id="partnership"
              role="tabpanel"
              aria-labelledby="partnership-tab"
            >
              <h3>Parceria com empresa</h3>

              <!-- Sem parceria ativa -->
              <div
                v-if="
                  !item.partnership ||
                  item.partnership.deleted_at ||
                  !item.partnership.info
                "
                class="row"
              >
                <div class="col-12">
                  <div class="card bg-light border-0">
                    <div class="card-body text-center py-5">
                      <i
                        class="fa-solid fa-handshake fa-3x text-muted mb-3"
                      ></i>
                      <p class="text-muted mb-0">
                        Este paciente não possui uma parceria ativa
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Com parceria ativa -->
              <div v-else class="row">
                <div class="col-12 col-lg-6">
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title mb-3">
                        <i class="fa-solid fa-building me-2 text-primary"></i>
                        Informações da Parceria
                      </h5>

                      <div class="list-group list-group-flush my-n3">
                        <!-- Empresa -->
                        <div class="list-group-item px-0">
                          <div class="row align-items-center">
                            <div class="col text-start">
                              <p class="text-muted mb-0">Empresa</p>
                            </div>
                            <div class="col-auto">
                              <p class="fw-bold mb-0">
                                <a
                                  :href="`${$paths.partners.detail}/${item.partnership.partnership_id}`"
                                  target="_blank"
                                  class="text-success"
                                >
                                  {{ item.partnership.info.company_name }}
                                  <i
                                    class="fa-solid fa-arrow-up-right-from-square ms-1"
                                  ></i>
                                </a>
                              </p>
                            </div>
                          </div>
                        </div>

                        <!-- Status -->
                        <div class="list-group-item px-0">
                          <div class="row align-items-center">
                            <div class="col text-start">
                              <p class="text-muted mb-0">Status</p>
                            </div>
                            <div class="col-auto">
                              <span
                                class="badge"
                                :class="
                                  item.partnership.info.status === 'active'
                                    ? 'bg-success'
                                    : 'bg-danger'
                                "
                              >
                                {{
                                  item.partnership.info.status === "active"
                                    ? "Ativo"
                                    : "Inativo"
                                }}
                              </span>
                            </div>
                          </div>
                        </div>

                        <!-- Desconto -->
                        <div class="list-group-item px-0">
                          <div class="row align-items-center">
                            <div class="col text-start">
                              <p class="text-muted mb-0">Desconto</p>
                            </div>
                            <div class="col-auto">
                              <p class="fw-bold mb-0 text-success">
                                {{ item.partnership.info.discount_percentage }}%
                              </p>
                            </div>
                          </div>
                        </div>

                        <!-- Código de Parceria -->
                        <div
                          class="list-group-item px-0"
                          v-if="item.partnership.partnership_code"
                        >
                          <div class="row align-items-center">
                            <div class="col text-start">
                              <p class="text-muted mb-0">Código</p>
                            </div>
                            <div class="col-auto">
                              <span class="badge bg-primary-soft text-primary">
                                <i class="fa-solid fa-ticket me-1"></i>
                                {{ item.partnership.partnership_code.code }}
                              </span>
                            </div>
                          </div>
                          <div
                            class="row mt-2"
                            v-if="item.partnership.partnership_code.title"
                          >
                            <div class="col-12">
                              <p class="small text-muted mb-0">
                                {{ item.partnership.partnership_code.title }}
                              </p>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-12">
                              <button
                                @click="openUserPartnershipCodeModal()"
                                class="btn btn-sm btn-outline-primary w-100"
                              >
                                <i class="fa-solid fa-pen-to-square me-1"></i>
                                Alterar código da empresa
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Subsídios (se existir) -->
                <div
                  class="col-12 col-lg-6"
                  v-if="item.partnership.info.max_spending_amount"
                >
                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title mb-3">
                        <i
                          class="fa-solid fa-hand-holding-dollar me-2 text-success"
                        ></i>
                        Subsídios Configurados
                      </h5>

                      <div class="list-group list-group-flush my-n3">
                        <!-- Valor máximo do subsídio -->
                        <div class="list-group-item px-0">
                          <div class="row align-items-center">
                            <div class="col text-start">
                              <p class="text-muted mb-0">
                                Valor máximo do subsídio
                              </p>
                            </div>
                            <div class="col-auto text-end">
                              <p class="fw-bold mb-0">
                                {{
                                  item.partnership.info.max_spending_amount
                                    | toCurrency
                                }}
                              </p>
                              <p
                                class="small text-muted mb-0"
                                v-if="item.partnership.info.spending_period"
                              >
                                {{
                                  formatPeriod(
                                    item.partnership.info.spending_period
                                  )
                                }}
                              </p>
                            </div>
                          </div>
                        </div>

                        <!-- Sessões por usuário -->
                        <div
                          class="list-group-item px-0"
                          v-if="item.partnership.info.appointments_per_user"
                        >
                          <div class="row align-items-center">
                            <div class="col text-start">
                              <p class="text-muted mb-0">Sessões por usuário</p>
                            </div>
                            <div class="col-auto text-end">
                              <p class="fw-bold mb-0">
                                {{
                                  item.partnership.info.appointments_per_user
                                }}
                              </p>
                              <p
                                class="small text-muted mb-0"
                                v-if="item.partnership.info.user_limit_period"
                              >
                                {{
                                  formatPeriod(
                                    item.partnership.info.user_limit_period
                                  )
                                }}
                              </p>
                            </div>
                          </div>
                        </div>

                        <!-- Valor máximo da sessão -->
                        <div
                          class="list-group-item px-0"
                          v-if="item.partnership.info.max_session_cost"
                        >
                          <div class="row align-items-center">
                            <div class="col text-start">
                              <p class="text-muted mb-0">
                                Valor máximo da sessão
                              </p>
                            </div>
                            <div class="col-auto">
                              <p class="fw-bold mb-0">
                                {{
                                  item.partnership.info.max_session_cost
                                    | toCurrency
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Mensagem quando não há subsídio -->
                <div class="col-12 col-lg-6" v-else>
                  <div class="card bg-light border-0">
                    <div class="card-body text-center py-4">
                      <i
                        class="fa-solid fa-info-circle fa-2x text-muted mb-2"
                      ></i>
                      <p class="text-muted mb-0 small">
                        Nenhum subsídio configurado para esta parceria
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Change Logs Tab -->
            <div
              class="tab-pane card-body fade"
              id="change-logs"
              role="tabpanel"
              aria-labelledby="change-logs-tab"
            >
              <h3>Histórico de Alterações</h3>
              <UserChangeLogsTab v-if="changeLogsLoaded" :userId="id" />
            </div>

            <!-- Notifications Tab -->
            <div
              class="tab-pane card-body fade"
              id="notifications"
              role="tabpanel"
              aria-labelledby="notifications-tab"
            >
              <h3>Notificações</h3>
              <AdminNotificationsList
                v-if="notificationsLoaded"
                :baseFilters="{ user_id: id }"
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
    <ModalComponent :title="'Sessão Gratuita'" id="freeAppointmentModal">
      <template v-slot:body>
        <div class="row">
          <div class="col-12 col-md-6">
            <TextInput
              label="Paciente"
              :value="item.nickname"
              :readOnly="true"
            />
          </div>
          <div class="col-12 col-md-6">
            <TextInput
              label="Data e horário"
              type="datetime-local"
              :model="$v.freeAppointmentForm.date"
              placeholder="Data e horário"
            />
          </div>
        </div>

        <p class="form-label text-muted">Psicólogo</p>
        <div class="card mb-2">
          <div class="card-body py-0">
            <SearchBar @onSearch="search" :isCard="false" />
          </div>
        </div>
        <div class="card card-custom mb-0">
          <div class="card-body">
            <LoadingContainer v-if="loadingItems" />

            <div
              class="d-flex border-bottom pb-3 mb-3 align-items-center justify-content-between cursor-pointer"
              v-for="(psychologist, index) of items"
              :key="index"
              @click="selectPsi(psychologist)"
            >
              <div class="d-flex align-items-center">
                <div
                  class="avatar"
                  v-if="
                    psychologist.profile_image &&
                    psychologist.profile_image != '1'
                  "
                >
                  <img
                    :src="`${$baseImageUrl}${psychologist.profile_image}`"
                    alt="..."
                    class="avatar-img avatar-img-sm rounded-circle"
                  />
                </div>
                <div v-else class="avatar avatar-sm">
                  <img
                    src="@/assets/img/avatar_placeholder.svg"
                    alt="..."
                    class="avatar-img rounded-circle"
                  />
                </div>
                <div class="ms-2">
                  <span class="fw-bold">
                    {{ psychologist.name }}
                    <i
                      v-if="psychologist.subscription"
                      class="fa-solid fa-circle-plus text-info"
                    ></i>
                  </span>
                  <span
                    class="small fw-bold text-danger"
                    v-if="psychologist.deleted_at"
                    >(Excluído)</span
                  >
                  <br />
                  <span>
                    {{ psychologist.email }}
                  </span>
                </div>
              </div>
              <i
                class="fa-solid fa-check-square text-primary"
                v-if="
                  $v.freeAppointmentForm.psychologist_id.$model ==
                  psychologist?.id
                "
              />
              <i class="fa-regular fa-square text-muted" v-else />
            </div>
            <FormButton
              v-if="!loadingItems && moreItemsToLoad"
              class="btn-link"
              label="Carregar mais"
              :loading="loadingMoreItems"
              @onClick="loadMore"
            />
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <FormButton
          label="Concluir"
          :loading="submitting"
          :disabled="$v.freeAppointmentForm.$invalid"
          class="btn w-15 btn-primary mb-3"
          @onClick="handleFreeAppointment"
        />
      </template>
    </ModalComponent>
    <ModalComponent :title="'Alterar email'" id="changeEmailModal">
      <template v-slot:body>
        <div class="mt-3">
          <TextInput
            label=""
            :model="$v.form.email"
            class="text-white"
            placeholder="Digite o novo email"
          />
          <p class="text-center text-danger">
            {{ errorMessage }}
          </p>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <FormButton
            label="Concluir"
            :loading="submitting"
            :disabled="$v.form.$invalid"
            class="btn w-15 btn-primary mb-3"
            @onClick="handleChangeEmail"
          />
        </div>
      </template>
    </ModalComponent>

    <!-- USER PARTNERSHIP CODE MODAL -->
    <ModalComponent
      :title="'Alterar código de parceria'"
      id="userPartnershipCodeModal"
    >
      <template v-slot:body>
        <!-- Loading -->
        <LoadingContainer v-if="loadingUserPartnershipCodes" />

        <!-- Lista de códigos -->
        <div v-else-if="userPartnershipCodes.length > 0">
          <p class="mb-3">
            Selecione o novo código de parceria para este paciente:
          </p>
          <div class="list-group">
            <div
              v-for="code in userPartnershipCodes"
              :key="code.id"
              @click="selectUserPartnershipCode(code.id)"
              class="list-group-item list-group-item-action"
              :class="{ active: selectedUserPartnershipCodeId === code.id }"
              style="cursor: pointer"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <i class="fa-solid fa-ticket me-2"></i>
                  <strong>{{ code.code }}</strong>
                  <span class="text-muted ms-2">- {{ code.title }}</span>
                </div>
                <i
                  v-if="selectedUserPartnershipCodeId === code.id"
                  class="fa-solid fa-check text-success"
                ></i>
              </div>
            </div>
          </div>
          <p
            class="text-danger text-center mt-3"
            v-if="userPartnershipCodeError"
          >
            {{ userPartnershipCodeError }}
          </p>
        </div>

        <!-- Sem códigos -->
        <div v-else>
          <EmptyState
            >Nenhum código de parceria disponível para esta
            parceria.</EmptyState
          >
        </div>
      </template>

      <template v-slot:footer>
        <FormButton
          v-if="userPartnershipCodes.length > 0"
          label="Concluir alteração"
          :loading="updatingUserPartnershipCode"
          :disabled="!selectedUserPartnershipCodeId"
          class="btn btn-primary mb-3"
          @onClick="handleUpdateUserPartnershipCode"
        />
      </template>
    </ModalComponent>

    <!-- Modal Reativar Conta -->
    <div
      class="modal fade"
      :class="{ show: showReactivateModal }"
      :style="{ display: showReactivateModal ? 'block' : 'none' }"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa-solid fa-rotate-left me-2"></i>
              Reativar conta excluída
            </h5>
            <button type="button" class="btn-close" @click="closeReactivateModal"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning">
              <strong>Atenção!</strong> Esta conta foi excluída anteriormente.
            </div>
            <p>Ao reativar esta conta, o usuário poderá acessar o aplicativo novamente com as mesmas credenciais.</p>
            <div class="form-check mt-4">
              <input
                class="form-check-input"
                type="checkbox"
                id="confirmReactivateCheckboxUser"
                v-model="confirmReactivate"
              />
              <label class="form-check-label" for="confirmReactivateCheckboxUser">
                <strong>Eu confirmo</strong> que desejo reativar esta conta
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeReactivateModal">Cancelar</button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!confirmReactivate || reactivating"
              @click="handleReactivateAccount"
            >
              <span v-if="reactivating" class="spinner-border spinner-border-sm me-1"></span>
              Reativar conta
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showReactivateModal" class="modal-backdrop fade show"></div>

    <!-- Modal Gerar Link Reset Senha -->
    <div
      class="modal fade"
      :class="{ show: showResetPasswordModal }"
      :style="{ display: showResetPasswordModal ? 'block' : 'none' }"
      tabindex="-1"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fa-solid fa-key me-2"></i>
              Gerar link de redefinição de senha
            </h5>
            <button type="button" class="btn-close" @click="closeResetPasswordModal"></button>
          </div>
          <div class="modal-body">
            <div v-if="!resetPasswordLink">
              <p>Será gerado um link para o usuário redefinir sua senha. Você poderá copiar e enviar para ele.</p>
              <button
                class="btn btn-primary w-100"
                :disabled="generatingResetLink"
                @click="handleGenerateResetLink"
              >
                <span v-if="generatingResetLink" class="spinner-border spinner-border-sm me-1"></span>
                Gerar link
              </button>
            </div>
            <div v-else>
              <div class="alert alert-success">
                <i class="fa-solid fa-check-circle me-1"></i>
                Link gerado com sucesso!
              </div>
              <label class="form-label text-muted">Link de redefinição:</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  :value="resetPasswordLink"
                  readonly
                />
                <button class="btn btn-outline-secondary" @click="copyResetLink">
                  <i class="fa-solid fa-copy"></i>
                </button>
              </div>
              <small class="text-muted">Copie e envie este link para o usuário</small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeResetPasswordModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showResetPasswordModal" class="modal-backdrop fade show"></div>

    <RecurrencyEditModal
      :recurrency="editingRecurrency"
      @close="editingRecurrency = null"
      @saved="onRecurrencyEditSaved"
    />
  </div>
</template>
<script>
import UserDetailController from "./UserDetailController";
export default UserDetailController;
</script>
<style scoped>
.card-custom {
  height: calc(100vh - 500px);
  overflow: scroll;
}

.recurrency-card {
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.15s;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.recurrency-card:hover {
  border-color: #dee2e6;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.recurrency-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid #f1f3f5;
  position: relative;
}

.recurrency-avatar-link {
  flex-shrink: 0;
  display: block;
  transition: transform 0.15s;
}

.recurrency-avatar-link:hover {
  transform: scale(1.05);
}

.recurrency-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background-color: #f8f9fa;
  display: block;
}

.recurrency-avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e9ecef;
  color: #adb5bd;
  font-size: 1.2rem;
}

.recurrency-header-info {
  flex: 1;
  overflow: hidden;
  min-width: 0;
}

.recurrency-name {
  font-weight: 600;
  color: #212529;
  font-size: 0.95rem;
  line-height: 1.2;
  display: block;
}

.recurrency-name-link {
  text-decoration: none;
  transition: color 0.15s;
}

.recurrency-name-link:hover {
  color: #2563eb;
  text-decoration: underline;
}

.recurrency-price {
  font-size: 0.85rem;
  color: #495057;
  margin-top: 2px;
}

.recurrency-price-suffix {
  color: #adb5bd;
  font-size: 0.75rem;
}

.recurrency-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}

.recurrency-status-badge.status-active {
  color: #0f5132;
  background-color: #d1e7dd;
}

.recurrency-status-badge.status-pending {
  color: #664d03;
  background-color: #fff3cd;
}

.recurrency-status-badge.status-cancelled {
  color: #842029;
  background-color: #f8d7da;
}

.recurrency-body {
  padding: 14px 16px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recurrency-info-line {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #495057;
}

.recurrency-info-line small {
  font-size: 0.75rem;
}

.recurrency-footer {
  padding: 0 16px 14px 16px;
  display: flex;
  gap: 8px;
}

.recurrency-summary {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 12px 16px;
  border: 1px solid #e9ecef;
}

.recurrency-value-change {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  padding: 8px 10px;
  background-color: #fff7ed;
  color: #92400e;
  border: 1px solid #fed7aa;
  border-radius: 6px;
}
</style>
